export default __webpack_public_path__ + "static/media/mode-67.efa80050.svg";